webpackJsonp([142629428675168],{

/***/ 512:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"OSDC Blog"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"What is Open Source? How to start with Open Source? How to step into Open-Source Development? These are some simple yet daunting questions…","fields":{"slug":"/Open-source-M1/"},"frontmatter":{"date":"20 September, 2018","title":"How to Open Source!"}}},{"node":{"excerpt":"One OS to rule them all,\nOne OS to find them.\nOne OS to call them all,\nAnd in salvation bind them.\nIn the bright land of Linux,\nWhere the…","fields":{"slug":"/wanna-play-linux-meetup0/"},"frontmatter":{"date":"20 September, 2018","title":"Wanna Play Linux Meetup"}}},{"node":{"excerpt":"This blog is about making a live CD/DVD from the main system on your hard drive. This is useful if you want to build a clean live CD, or if…","fields":{"slug":"/custom-ubuntu-live-cd/"},"frontmatter":{"date":"14 September, 2018","title":"Custom Live Ubuntu"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-5d59a8c8990ad688a92e.js